import { useEffect, useState } from 'react';
import { trackEvent } from '../../../utils/analytics';

export default function StickyCtaBar() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 400);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToCalendar = () => {
    trackEvent('calendar_click');
    const el = document.getElementById('calendar');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-40 transition-transform duration-300 ${
        visible ? 'translate-y-0' : 'translate-y-full'
      }`}
    >
      {/* Desktop */}
      <div className="hidden md:flex items-center justify-between bg-[#111111] border-t border-[#2a2a2a] px-8 py-3 shadow-2xl">
        <div className="flex items-center gap-6">
          <div className="flex items-center gap-2 text-gray-300 text-sm">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-shield-check-fill text-[#dc2626] text-base"></i>
            </div>
            <span>Attorney-Client Privilege Protected</span>
          </div>
          <div className="w-px h-4 bg-[#2a2a2a]"></div>
          <div className="flex items-center gap-2 text-gray-300 text-sm">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-time-line text-[#dc2626] text-base"></i>
            </div>
            <span>Free 30-Min Discovery Call</span>
          </div>
          <div className="w-px h-4 bg-[#2a2a2a]"></div>
          <div className="flex items-center gap-2 text-gray-300 text-sm">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-user-star-fill text-[#dc2626] text-base"></i>
            </div>
            <span>Curated by Epic Real Estate · Executed by KKOS Lawyers</span>
          </div>
        </div>
        <button
          onClick={scrollToCalendar}
          className="flex items-center gap-2 px-6 py-2.5 bg-[#dc2626] hover:bg-[#b91c1c] text-white text-sm font-bold rounded-md transition-colors cursor-pointer whitespace-nowrap"
        >
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-calendar-check-line text-sm"></i>
          </div>
          Schedule Your Free Strategy Call
        </button>
      </div>

      {/* Mobile */}
      <div className="flex md:hidden items-center justify-between bg-[#111111] border-t border-[#2a2a2a] px-4 py-3 shadow-2xl gap-3">
        <div className="flex flex-col">
          <span className="text-white text-xs font-bold leading-tight">Free Discovery Call</span>
          <span className="text-gray-400 text-xs leading-tight">Attorney-Client Privilege · No Obligation</span>
        </div>
        <button
          onClick={scrollToCalendar}
          className="flex items-center gap-1.5 px-4 py-2.5 bg-[#dc2626] hover:bg-[#b91c1c] text-white text-xs font-bold rounded-md transition-colors cursor-pointer whitespace-nowrap"
        >
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-calendar-check-line text-sm"></i>
          </div>
          Book Now
        </button>
      </div>
    </div>
  );
}
